export default __webpack_public_path__ + "static/media/icon-Hegic_circled.e94c722c.svg";